import React from "react";
import styled from "styled-components";

// https://loading.io/css/
const PullToRefreshing = () => {
  return (
    <Spinner>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </Spinner>
  );
};

const Spinner = styled.div`
  display: inline-block;
  position: relative;
  width: 40px;
  height: 40px;
  margin-top: 15px;

  div {
    transform-origin: 20px 20px;
    animation: lds-spinner 0.8s linear infinite;
  }
  div:after {
    content: " ";
    display: block;
    position: absolute;
    top: 6px;
    left: 18px;
    width: 3px;
    height: 9px;
    border-radius: 20%;
    background: gray;
  }
  div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -0.7s;
  }
  div:nth-child(2) {
    transform: rotate(45deg);
    animation-delay: -0.6s;
  }
  div:nth-child(3) {
    transform: rotate(90deg);
    animation-delay: -0.5s;
  }
  div:nth-child(4) {
    transform: rotate(135deg);
    animation-delay: -0.4s;
  }
  div:nth-child(5) {
    transform: rotate(180deg);
    animation-delay: -0.3s;
  }
  div:nth-child(6) {
    transform: rotate(225deg);
    animation-delay: -0.2s;
  }
  div:nth-child(7) {
    transform: rotate(270deg);
    animation-delay: -0.1s;
  }
  div:nth-child(8) {
    transform: rotate(315deg);
    animation-delay: -0s;
  }
  @keyframes lds-spinner {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;

export default PullToRefreshing;
